import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const NtpDiagnostic = React.lazy(async () => ({
    default: (await import('@oc/ntp-diagnostic/module')).NtpDiagnostic
}))

export function NtpDiagnosticComponent() {
    return <SuspenseWhileLoading LazyComponent={NtpDiagnostic} />
}
